<svelte:options runes={true} />

<script lang="ts">
	import { Modal } from "flowbite-svelte";
	import Icon from "#lib/components/Icon.svelte";
	import Button from "#lib/ui/Button/index.js";
	import type { ButtonProps } from "flowbite-svelte/Button.svelte";
	import type { Snippet } from "svelte";

	interface Props {
		open: boolean;
		children: Snippet;
		buttonDataActionName: string;
		title?: string;
		confirmProps?: ButtonProps;
		confirmLabel?: string;
		cancelLabel?: string;
		hideConfirm?: boolean;
		size?: "xs" | "sm";
		onContinue?: () => void;
		onCancel?: () => void;
	}

	let { open = $bindable(), children, buttonDataActionName, title, confirmProps, confirmLabel = "Yes, I'm sure", cancelLabel = "No, cancel", hideConfirm = false, size = "xs", onContinue, onCancel }: Props = $props();

	function handleContinue() {
		onContinue?.();
		open = false;
	}

	function handleCancel() {
		onCancel?.();
		open = false;
	}
</script>

{#if title}
	<Modal {size} {title} bind:open>
		<div class="text-gray-800">{@render children?.()}</div>
		<div slot="footer" class="flex w-full flex-wrap justify-end gap-2 *:whitespace-nowrap">
			<Button color="light" data-action-name={buttonDataActionName} data-action-title="Cancel" on:click={handleCancel}>{cancelLabel}</Button>
			{#if !hideConfirm}
				<Button color={confirmProps?.color ?? "red"} class={confirmProps?.class} data-action-name={buttonDataActionName} data-action-title="Continue" on:click={handleContinue}>{confirmLabel}</Button>
			{/if}
		</div>
	</Modal>
{:else}
	<Modal {size} bind:open>
		<div class="flex flex-col items-center gap-4 p-6">
			<div class="flex flex-col items-center gap-2 text-center">
				<Icon class="text-gray-800" name="exclamation-circle" />
				<span>{@render children?.()}</span>
			</div>
			<div class="flex flex-none flex-wrap justify-center gap-2 *:whitespace-nowrap">
				{#if !hideConfirm}
					<Button color={confirmProps?.color ?? "red"} class={confirmProps?.class} data-action-name={buttonDataActionName} data-action-title="Continue" on:click={handleContinue}>{confirmLabel}</Button>
				{/if}
				<Button color="light" data-action-name={buttonDataActionName} data-action-title="Cancel" on:click={handleCancel}>{cancelLabel}</Button>
			</div>
		</div>
	</Modal>
{/if}
